// VUEX STORE
import Vue from 'vue'
import Vuex from 'vuex'

import db from '@/db'
import firebase from 'firebase'
import {Howl} from 'howler'

Vue.use(Vuex)

export default new Vuex.Store({
	state : {
		currentUser : null,
		mode : 'light',
		isSidebarActive : false,
		sound : null,
		isPlaying: null,
		isStoping: null,
		seekTime: null,
		isLoading: false
	},
	mutations: {
		setCurrentUser (state, payload) {
			state.currentUser = payload
		},
		setMode (state, payload) {
			state.mode = payload
		},
		setSidebarActive(state, payload) {
			state.isSidebarActive = payload
		},
		playSound (state, payload) {
			if (state.isPlaying == payload && state.isStoping == payload) { //resume playing
				state.sound.play()
				state.isStoping = null
			}else if(state.isPlaying == payload && state.isStoping != payload){ // jika dua kali tekan play
				state.sound.pause()
				state.isStoping = payload
			}else{
				state.isLoading = true
				state.isPlaying = payload
				if (state.sound) { // menghentikan semua audio yang di play
					state.sound.unload()
					state.isStoping = null
				}
				state.sound = new Howl({
					src: [payload],
					html5: true,
					onload: function() {
						state.isLoading = false		
						state.sound.play()
						let increment = firebase.firestore.FieldValue.increment(+1)
						db.collection('episodes').where('audio','==',payload).limit(1).get().then((episodes) => {
							episodes.forEach((episode) => {
								db.collection('recentPlay').doc(episode.id+state.currentUser.uid).set({
									eid: episode.id,
									uid: state.currentUser.uid,
									created_at: new Date(),
								},{ merge: true });
								db.collection('episodes').doc(episode.id).update({
									listener: increment
								})
							})
						})
					},
					onplay: function() {
						clearInterval()
						setInterval(() => {
							state.seekTime = Math.round(state.sound.seek())
						}, 50)
					},
					onend: function() {
						clearInterval()
						state.isPlaying = null
						state.isStoping = null
						state.sound.stop()
					},
					onseek: function() {
						state.isLoading = false
					}
				})
			}
		},
		pauseSound (state, payload) {
			state.sound.pause()
			state.isStoping = payload
		},
		seekChange (state, payload) {
			state.seekTime = Math.round(payload)
			state.sound.seek(payload)
		},
		stop (state) {
			state.sound.stop()
			state.isPlaying = null
		}
	}
})